module.exports = __webpack_public_path__ + "static/media/averaged_trajectories_clean.d1e0f3f2.png";